///
/// EarthBrowser
///
/// Created by Matt Giger on 9/22/2026
/// Copyright (c) 2026 Geodata Labs
///
/// Re-runs a callback whenever a dataset layer's data is refreshed from the
/// database (background sync, initial cached-data load, or manual refresh).
/// Used by dataset browser windows to keep their tables in sync with the map
/// instead of showing a snapshot from when the window was opened.
///

import { useEffect, useRef } from 'react'
import { useAppSelector } from '@/redux/store'

export function useDatasetLayerRefresh(layerName: string, onRefresh: () => void): void {
	const layerManager = useAppSelector(state => state.datasetScene.layerManager)

	// Keep the latest callback in a ref so the subscription doesn't churn
	// when callers pass a new function identity each render
	const callbackRef = useRef(onRefresh)
	callbackRef.current = onRefresh

	useEffect(() => {
		if (!layerManager) return
		return layerManager.addRefreshListener(layerName, () => callbackRef.current())
	}, [layerManager, layerName])
}
